import ssdkResponseData from './ssdkResponseData';
/**
 * send notification to wireless web that confirmation was failed
 */
export default function confirmFailed(...args) {
    return window.webPosSalesSdk.confirmationResult(...args).then(ssdkResponseData);
}
